import { type ReactNode } from 'react'

export interface FloatingMenuItem {
  id: string
  icon?: string
  iconColor?: string
  iconSize?: number
  label?: string
  tooltip: string
  onClick: () => void
  disabled?: boolean
  dividerBefore?: boolean
}

interface FloatingMenuProps {
  items: FloatingMenuItem[]
  children?: ReactNode
  className?: string
}

export const FloatingMenu = ({ items, children, className = '' }: FloatingMenuProps) => {
  return (
    <div
      className={`flex items-center gap-0.5 bg-[#1e293b] rounded-xl p-1 shadow-2xl border border-white/10 animate-in fade-in zoom-in-95 duration-200 ${className}`}
      style={{ pointerEvents: 'auto' }}
      onMouseDown={(e) => e.stopPropagation()}
      onMouseDownCapture={(e) => e.stopPropagation()}
      onMouseUp={(e) => e.stopPropagation()}
      onPointerDown={(e) => e.stopPropagation()}
      onPointerDownCapture={(e) => e.stopPropagation()}
    >
      {items.map((item, index) => (
        <span key={item.id} className="flex items-center gap-0.5">
          {item.dividerBefore && index > 0 && <FloatingMenuDivider />}
          <ButtonItem item={item} />
        </span>
      ))}

      {children}
    </div>
  )
}

import { Icon } from '../ui/icon'

const ButtonItem = ({ item }: { item: FloatingMenuItem }) => {
  return (
    <button
      onClick={item.onClick}
      disabled={item.disabled}
      className={`flex items-center justify-center rounded-lg text-white hover:bg-white/10 transition-colors cursor-pointer ${item.label ? 'h-9 px-3 text-xs font-medium gap-1.5' : 'h-9 w-9'} ${item.disabled ? 'opacity-40 cursor-not-allowed hover:bg-transparent' : ''}`}
      title={item.tooltip}
    >
      {item.icon && <Icon icon={item.icon} size={item.iconSize ?? 18} primaryColor={item.iconColor} />}
      {item.label && <span>{item.label}</span>}
    </button>
  )
}

export const FloatingMenuDivider = () => (
  <div className="w-px h-5 bg-white/10 mx-0.5" />
)
